import AccordionBlock from 'libs/wordpress/content/cmsBlocks/AccordionBlock';
import PropTypes from 'prop-types';
import React from 'react';
import { bleedMargins } from 'config/theme/contentMargins';
import styled from 'libs/styled';

const Section = styled('section')``;

const AccordionLayout = ({ last = false, ...rest }) => (
    <Section mx={bleedMargins} mt={['-17px', null, '-25px']} mb={last ? '-1px' : ['16px', null, '24px']}>
        <AccordionBlock {...rest} />
    </Section>
);

AccordionLayout.propTypes = {
    first: PropTypes.bool,
    last: PropTypes.bool,
};

export default AccordionLayout;
